import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GetTemplateService {

  constructor( private readonly http  : HttpClient) { }
  baseURL = environment.baseAPIURL;

  getImportTemplate() {
    return this.http
      .get(
        `${this.baseURL}/aetImports/getAetImportTemplate`,
        {observe: 'response', responseType: 'blob'}
      )
      .pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}
